var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 44,
    viewBox: "0 0 90 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 43,
    rx: 3.5,
    stroke: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_10275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9329 31.8759L39.3868 12.233H44.7837L41.4376 31.8759H35.9329Z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9329 31.8759L40.3583 12.233H44.7837L41.4376 31.8759H35.9329Z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.975 12.4514C59.8956 12.0149 58.1686 11.5784 56.0099 11.5784C50.6131 11.5784 46.7274 14.3065 46.7274 18.2351C46.7274 21.1815 49.4258 22.7093 51.5845 23.6915C53.7432 24.6736 54.3909 25.3284 54.3909 26.2014C54.3909 27.5109 52.6639 28.1657 51.1528 28.1657C48.994 28.1657 47.8067 27.8383 45.9718 27.0744L45.2162 26.747L44.4607 31.2212C45.7559 31.7669 48.1305 32.3125 50.6131 32.3125C56.3337 32.3125 60.1115 29.5843 60.1115 25.4375C60.1115 23.1458 58.7083 21.3998 55.4702 19.9811C53.5274 18.999 52.3401 18.4534 52.3401 17.4712C52.3401 16.5982 53.3115 15.7252 55.4702 15.7252C57.3051 15.7252 58.6004 16.0526 59.5718 16.4891L60.1115 16.7073L60.975 12.4514Z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.975 12.4514C59.8956 12.0149 58.1686 11.5784 56.0099 11.5784C50.6131 11.5784 47.6988 14.3065 47.6988 18.2351C47.6988 21.1815 49.4258 22.7093 51.5845 23.6915C53.7432 24.6736 54.3909 25.3284 54.3909 26.2014C54.3909 27.5109 52.6639 28.1657 51.1528 28.1657C48.994 28.1657 47.8067 27.8383 45.9718 27.0744L45.2162 26.747L44.4607 31.2212C45.7559 31.7669 48.1305 32.3125 50.6131 32.3125C56.3337 32.3125 60.1115 29.5843 60.1115 25.4375C60.1115 23.1458 58.7083 21.3998 55.4702 19.9811C53.5274 18.999 52.3401 18.4534 52.3401 17.4712C52.3401 16.5982 53.3115 15.7252 55.4702 15.7252C57.3051 15.7252 58.6004 16.0526 59.5718 16.4891L60.1115 16.7073L60.975 12.4514Z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2573 12.233C68.9621 12.233 67.9906 12.3422 67.4509 13.6517L59.3557 31.8759H65.1843L66.2636 28.6021H73.1716L73.8192 31.8759H79.0002L74.4668 12.233H70.2573ZM67.7748 25.3283C68.0986 24.3461 69.9335 19.5445 69.9335 19.5445C69.9335 19.5445 70.3652 18.3442 70.689 17.5803L71.0129 19.4354C71.0129 19.4354 72.0922 24.3461 72.3081 25.4374H67.7748V25.3283Z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5525 12.233C70.2573 12.233 69.2859 12.3422 68.7462 13.6517L59.3557 31.8759H65.1843L66.2636 28.6021H73.1716L73.8192 31.8759H79.0002L74.4668 12.233H71.5525ZM67.7748 25.3283C68.2065 24.237 69.9335 19.5445 69.9335 19.5445C69.9335 19.5445 70.3652 18.3442 70.689 17.5803L71.0129 19.4354C71.0129 19.4354 72.0922 24.3461 72.3081 25.4374H67.7748V25.3283Z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0027 25.9829L25.463 23.1456C24.4916 19.8718 21.3614 16.2706 17.9075 14.5246L22.7646 31.9849H28.5932L37.336 12.342H31.5075L26.0027 25.9829Z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0027 25.9829L25.463 23.1456C24.4916 19.8718 21.3614 16.2706 17.9075 14.5246L22.7646 31.9849H28.5932L37.336 12.342H32.5868L26.0027 25.9829Z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.233L11.9714 12.4513C18.8794 14.0882 23.6286 18.235 25.4635 23.1457L23.5206 13.8699C23.1968 12.5604 22.2254 12.233 21.0381 12.233H11Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.233C17.9079 13.8699 23.6286 18.1259 25.4635 23.0366L23.6286 15.2886C23.3048 13.9791 22.2254 13.2152 21.0381 13.2152L11 12.233Z",
    fill: "#F7981D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.233C17.9079 13.8699 23.6286 18.1259 25.4635 23.0366L24.1683 18.7807C23.8444 17.4711 23.4127 16.1616 21.9016 15.616L11 12.233Z",
    fill: "#ED7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4007 25.3283L27.7309 21.618L26.0039 25.7649L25.5722 23.0367C24.6007 19.7629 21.4706 16.1617 18.0166 14.4156L22.8737 31.876H28.7023L31.4007 25.3283Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4391 31.8759L36.7978 27.0743L35.9343 31.8759H41.4391Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8514 25.1101C54.2832 25.5466 54.499 25.874 54.3911 26.3105C54.3911 27.62 52.6641 28.2748 51.153 28.2748C48.9943 28.2748 47.807 27.9474 45.972 27.1835L45.2165 26.8561L44.4609 31.3303C45.7562 31.876 48.1308 32.4216 50.6133 32.4216C54.0673 32.4216 56.8736 31.4395 58.4927 29.6934L53.8514 25.1101Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1116 31.8758H65.1846L66.2639 28.602H73.1719L73.8195 31.8758H79.0004L77.1655 23.9096L70.6893 17.5802L71.0131 19.3262C71.0131 19.3262 72.0925 24.2369 72.3084 25.3282H67.7751C68.2068 24.2369 69.9338 19.5445 69.9338 19.5445C69.9338 19.5445 70.3655 18.3441 70.6893 17.5802",
    fill: "#051244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_10275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.0eff91edf9bad271b4ee97a89cb6bec1.svg";
export { ForwardRef as ReactComponent };